module.exports = __webpack_public_path__ + "static/media/icon-heart-line.64317c90.svg";